import React, { useEffect, useRef, useState } from "react";

import { Button, Props as ButtonProps } from "../buttons/Button";
import styles from "./Dropdown.module.scss";

const SMALL_SCREEN_BREAK_POINT = 960;

interface DropdownItem {
  id: string | number;
  title: string;
}

interface Props {
  items: DropdownItem[];
  buttonProps: Omit<ButtonProps, "onClick">;
  onItemClick: (index: number) => void;
}

export const Dropdown = ({ items, buttonProps, onItemClick }: Props) => {
  const [dropdown, setDropdown] = useState(false);

  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handler = (event: MouseEvent | TouchEvent) => {
      if (dropdown && wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    if (window.innerWidth > SMALL_SCREEN_BREAK_POINT) {
      setDropdown(true);
    }
  };

  const onMouseLeave = () => {
    if (window.innerWidth > SMALL_SCREEN_BREAK_POINT) {
      setDropdown(false);
    }
  };

  const handleClick = (index: number) => () => onItemClick(index);

  return (
    <div ref={wrapperRef} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={styles.dropdown__wrapper}>
      <Button
        trailing={<i className={`icon icon-arrow-down`} />}
        {...buttonProps}
        onClick={() => setDropdown((prev) => !prev)}
      />
      <ul
        className={`${styles.dropdown__list} ${
          dropdown && !buttonProps.disabled ? styles["dropdown__list--show"] : ""
        }`}
      >
        {items.map((item, index) => (
          <li
            key={item.id}
            id={`button_dropdown_${item.id}`}
            className={styles.dropdown__item}
            onClick={handleClick(index)}
          >
            {item.title}
          </li>
        ))}
      </ul>
    </div>
  );
};
